export default function StatusChip({
  label,
  tone = 'default',
  className = '',
  title,
}) {
  const toneClassName = {
    success: 'border-[rgba(var(--success),0.28)] bg-[rgba(var(--success),0.12)] text-[rgb(var(--success))]',
    warning: 'border-[rgba(var(--warning),0.28)] bg-[rgba(var(--warning),0.14)] text-[rgb(var(--warning))]',
    danger: 'border-[rgba(var(--danger),0.28)] bg-[rgba(var(--danger),0.12)] text-[rgb(var(--danger))]',
    brand: 'border-[rgba(var(--brand),0.28)] bg-[rgba(var(--brand),0.12)] text-[rgb(var(--brand-700))] dark:text-[rgb(var(--brand))]',
    muted: 'border-[rgba(var(--border),0.72)] bg-[rgba(var(--subpanel),0.9)] text-[rgba(var(--fg),0.74)]',
    default: 'border-[rgba(var(--border),0.72)] bg-[rgba(var(--panel),0.92)] text-[rgb(var(--fg))]',
  }[tone] || 'border-[rgba(var(--border),0.72)] bg-[rgba(var(--panel),0.92)] text-[rgb(var(--fg))]';

  return (
    <span
      title={title || label}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${toneClassName} ${className}`.trim()}
    >
      {label}
    </span>
  );
}
